export default __webpack_public_path__ + "static/media/portrait-min.ed48fc93.jpg";